module.exports = __webpack_public_path__ + "static/media/about.df012406.jpg";